import { docReady } from './docReady';
docReady(() => {
  const navToggles = document.getElementsByClassName('mobile-nav-toggle');
  for (let toggle of navToggles) {
    toggle.addEventListener('click', (_) => {
      document.getElementById('app-nav').classList.toggle('hidden');
    });
  }
});
